import { captureException } from "../sentry";
import { HandlerCallback, HandlerCallbackArgs } from "./handler";

export const PIXEL_RETRY_DELAY_MS = 5000;
export const PIXEL_RETRY_MAX_ATTEMPTS = 10;

export function fireCallbackWithRetry(
  callback: HandlerCallback,
  args: HandlerCallbackArgs,
  delay = PIXEL_RETRY_DELAY_MS,
  maxAttempts = PIXEL_RETRY_MAX_ATTEMPTS,
  attempt = 0
): void {
  try {
    callback(args);
  } catch (e) {
    // In Non-Production environments, log the exception for easy debugging.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error(e);
    }
    const nextAttempt = attempt + 1;
    if (nextAttempt < maxAttempts) {
      setTimeout(() => {
        fireCallbackWithRetry(callback, args, delay, maxAttempts, nextAttempt);
      }, delay);
    } else {
      captureException(e);
    }
  }
}

/**
 * This function is used by some of the Facebook Pixels for creating our custom event_id
 * Used for deduplication between browser pixel and server pixel
 * @param userId
 */
export function generateEventId(userId): string {
  const currentTimestamp = new Date().getTime();

  return `${userId}_${currentTimestamp}`;
}
